import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

import type { Refund } from '~/api/care-folders/types/care-folder'

export function subunitToUnits(refund: Refund) {
  const currentLocale = useI18nLocale()
  const { amount, currency } = refund.monetaryAmount

  const options = Intl.NumberFormat(toBcp47Locale(currentLocale), {
    style: 'currency',
    currency,
  }).resolvedOptions()

  const { minimumFractionDigits } = options

  return (Number(amount) / 10 ** (minimumFractionDigits || 0)).toString()
}
